import { db } from '../lib/database';
import { questionResponseService } from '../services/questionResponseService';

export const dataMigrationUtils = {
  runMigration: async () => {
    try {
      const forms = await db.forms.toArray();
      for (const form of forms) {
        if (form.sections || form.questions) {
          await questionResponseService.storeFormQuestions(form);
        }
      }
      
      const submissions = await db.submissions.toArray();
      for (const submission of submissions) {
        if (submission.answers) {
          await questionResponseService.storeFormResponses(submission);
        }
      }
      
      return { success: true, forms: forms.length, submissions: submissions.length };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
};